import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Quote, ChevronLeft, ChevronRight } from "lucide-react";

export default function TestimonialSlider({ items = [], dark = false }) {
  const [i, setI] = useState(0);
  const n = items.length;
  useEffect(() => {
    if (n <= 1) return;
    const t = setInterval(() => setI((x) => (x + 1) % n), 7000);
    return () => clearInterval(t);
  }, [n]);
  if (n === 0) return null;
  const go = (d) => setI((x) => (x + d + n) % n);
  const t = items[i];

  return (
    <div data-testid="testimonial-slider" className="relative">
      <Quote size={56} className={`${dark ? "text-white/10" : "text-[rgb(var(--rgh-primary-rgb)/0.10)]"}`} />
      <div className="min-h-[180px] sm:min-h-[150px]">
        <AnimatePresence mode="wait">
          <motion.blockquote key={i}
            initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -16 }}
            transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}>
            <p className={`text-xl sm:text-2xl md:text-[28px] leading-snug font-medium tracking-tight ${dark ? "text-white" : "text-[#0A0A0A]"}`}>
              “{t.quote}”
            </p>
            <footer className="mt-6">
              <p className="text-base font-semibold text-[var(--rgh-primary)]">{t.name}</p>
              <p className={`text-sm ${dark ? "text-white/50" : "text-[#525252]"}`}>{t.location}</p>
            </footer>
          </motion.blockquote>
        </AnimatePresence>
      </div>

      {n > 1 && (
        <div className="mt-8 flex items-center gap-4">
          <div className="flex gap-2">
            {items.map((_, idx) => (
              <button key={idx} onClick={() => setI(idx)} data-testid={`testimonial-dot-${idx}`} aria-label={`Testimonial ${idx + 1}`}
                className={`h-1.5 rounded-full transition-all duration-300 ${idx === i ? "w-8 bg-[var(--rgh-primary)]" : `w-2.5 ${dark ? "bg-white/25" : "bg-black/15"}`}`} />
            ))}
          </div>
          <div className="ml-auto flex gap-2">
            <button onClick={() => go(-1)} data-testid="testimonial-prev" className={`inline-flex h-10 w-10 items-center justify-center rounded-full border transition-colors duration-200 ${dark ? "border-white/15 text-white hover:bg-white/10" : "border-black/10 text-[#0A0A0A] hover:bg-black/5"}`}><ChevronLeft size={18} /></button>
            <button onClick={() => go(1)} data-testid="testimonial-next" className={`inline-flex h-10 w-10 items-center justify-center rounded-full border transition-colors duration-200 ${dark ? "border-white/15 text-white hover:bg-white/10" : "border-black/10 text-[#0A0A0A] hover:bg-black/5"}`}><ChevronRight size={18} /></button>
          </div>
        </div>
      )}
    </div>
  );
}
